import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { BIG_MARGIN, colorsPalette, LARGE_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: 'relative',
      flexBasis: '48%',
      marginLeft: 'auto',
      height: 190,
      marginBottom: -BIG_MARGIN,
      [theme.breakpoints.up('sm')]: {
        height: 240,
        marginBottom: -LARGE_MARGIN,
      },
      [theme.breakpoints.up('md')]: {
        height: 'initial',
        marginBottom: 0,
      },
      '&:after': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 2,
        display: 'block',
        width: '100%',
        height: '100%',
        background: `linear-gradient(0deg, ${colorsPalette.blueDark} 2%, rgba(0, 0, 0, 0) 100%);`,
        [theme.breakpoints.up('md')]: {
          left: -2,
          top: 0,
          background: `linear-gradient(90deg, ${colorsPalette.blueDark} 2%, rgba(0, 0, 0, 0) 100%);`,
        },
      },
      '&:before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        display: 'block',
        width: '100%',
        height: '100%',
        background:
          'linear-gradient(270deg, rgba(147, 147, 250, 0.15) 0%, rgba(134, 134, 241, 0.2) 100%)',
        mixBlendMode: 'color',
      },
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
  }),
);

export default useStyles;
